import React, { Component, ReactNode } from 'react'
import { UncaughtErrorPage } from './uncaught-error-page'
import { rollbar } from '../../infra/rollbar.config'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class CustomErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
    rollbar.error(error, { errorInfo })
  }

  public reset = () => {
    this.setState({ hasError: false, error: null })
  }

  public render() {
    if (this.state.hasError) {
      return (
        <UncaughtErrorPage
          error={this.state.error || undefined}
          reset={this.reset}
        />
      )
    }

    return this.props.children
  }
}
